import { render, staticRenderFns } from "./front-link.vue?vue&type=template&id=2f75824c&scoped=true"
import script from "./front-link.vue?vue&type=script&lang=js"
export * from "./front-link.vue?vue&type=script&lang=js"
import style0 from "./front-link.vue?vue&type=style&index=0&id=2f75824c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75824c",
  null
  
)

export default component.exports